var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box-wrapper"},[(_vm.step === 'request')?_c('RequestPasswordForm'):_vm._e(),_vm._v(" "),(_vm.step === 'instructions')?_c('Instructions'):_vm._e(),_vm._v(" "),(_vm.step === 'reset')?_c('ResetPasswordForm'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }